import { useNavigate } from 'react-router-dom';
import * as hook from '../hooks/export';
import * as style from '../utils/general_style';
import * as links from '../utils/general_links';
import { allInputs } from '../utils/form_data';
import inputValidator from '../utils/form_functions';
import * as form from '../components/form/export';

function Contact() {
    const page = 'contact';

    const [checked, setChecked] = hook.useCheckState();
    const saveInputValue = (e) => {
        sessionStorage.setItem(`${page}_${e.target.name}`, e.target.value);
    };

    const navigate = useNavigate();
    const handleSubmit = (e) => {
        e.preventDefault();
        setTimeout(function() {
            navigate(links.ROUTES.home)
        }, 800);
    };

    const inputs = allInputs.filter(input => input.forms.includes(page));
    const [validationState, setValidationState] = hook.useValidationState(inputs)
    const validateInputData = (e) => {
        let isValidated = inputValidator(e.target.name, e.target.value);
        setValidationState(prevState => ({...prevState, [e.target.name]: isValidated}));
    };

	return (
        <div className='AppBody noCTABar'>
			<section style={style.ELEMENT_BLOCK_WHITE}>
                <div style={{...style.COLUMN_CENTER, width: '100%'}}>
                    <h1 style={style.TITLE}>Demande de contact</h1>
                    <p style={{fontSize: '16px', marginBottom: style.SPACE.medium}}>Expliquez-nous votre demande et un conseiller <span style={style.PRESENTIS}>Presentis</span> reviendra vers vous très rapidement.</p>
                </div>
                <form method='post' onSubmit={ handleSubmit }>
                    <fieldset style={{...style.FIELDSET, ...style.COLUMN_CENTER}}>
                        <legend style={style.LEGEND}>Prise de contact</legend>
                        <div style={{width: '94px', height: '94px', position: 'relative', marginBottom: style.SPACE.large}}><i className="fa-regular fa-message" style={{fontSize: '92px', position: 'absolute', top: '0', left: '0', color: style.COLORS.primary, filter: `drop-shadow(0px 4px 4px ${style.COLORS.secondary_trans})`}}></i></div>
                        <div style={{...style.ROW_SPACE_BETWEEN, width: '100%', flexWrap: 'wrap'}}>
                            {inputs.map(({ label, name, type, required, options, devidedInputs }, index) => (
                                <form.CustomInput label={ label } type={ type } name={ name } required={ required } onChange={ saveInputValue } onBlur={ e => validateInputData(e) } validationState={ validationState[name] ? '0' : '1' } keyword={ page } form={ page } options={ options } devidedInputs={ devidedInputs } size={ (inputs.length === index + 1 && ((index + 1) % 2) !== 0) ? 'full' : '' } key={ index } />
                            ))}
                        </div>
                        <div style={{...style.COLUMN_START, width: '100%', margin: `${style.SPACE.small} 0px`}}>
                            <label htmlFor='message' style={{marginBottom: style.SPACE.small}}>Message<form.RequiredSpan required={ true }/></label>
                            <textarea name='message' id='message' style={{...style.INPUT, maxWidth: 'inherit', height: 'auto', resize: 'none'}} rows='5' required="required" onChange={ saveInputValue } defaultValue={sessionStorage.getItem(`${page}_message`)} ></textarea>
                        </div>
                        <div style={{cursor: 'pointer', margin: `${style.SPACE.medium} 0px`}}>
                            <form.Checkbox id='contactConditions' checked={ checked } onChange={ setChecked } label={<p style={{fontSize: '14px', textAlign: 'center'}}>En soumettant ce formulaire, j'accepte que les informations saisies soient utilisées pour me recontacter, je reconnais avoir pris connaissance de votre politique de confidentialité.</p>}/>
                        </div>
                        <div style={{margin: `${style.SPACE.medium} 0px`}}>
                            <form.SubmitButton label={'Envoi'} clear={page} />
                        </div>
                    </fieldset>
                    <div style={{...style.ROW_END, margin: `${style.SPACE.small} 0px`}}>
                        <form.RequiredSpan required={ true } /><p>informations requises</p>
                    </div>
                </form>
            </section>
        </div>
	);
};

export default Contact;